






































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import SelectComponent from "@/components/common/parts/SelectComponent.vue";
import InputTextComponent from "@/components/common/parts/InputTextComponent.vue";
import { GetNoticeResponse } from "@/typescript/api_client/emesh_api/notifications/types";
import DisplayFilterMenuComponent from "@/components/pages/store_groups/DisplayFilterMenuComponent.vue";
import { getCompanyEditApi } from "@/typescript/api_client/emesh_api/companies/company_edit_api";
import { getStoregroupEditApi } from "@/typescript/api_client/emesh_api/stores/storegroup_edit_api";
import { DisplayFilterMenu } from "@/typescript/pages/store_groups/index.ts";
import { GetCompanyEditResponse } from "@/typescript/api_client/emesh_api/companies/types";
import { GetStoregroupEditResponse } from "@/typescript/api_client/emesh_api/stores/types";
import {
  SelectedCompany,
  SelectedStoregroup
} from "@/typescript/pages/store_groups/types";
export {
  DisplayFilterMenu,
  GetNoticeResponse,
  GetCompanyEditResponse,
  GetStoregroupEditResponse,
  SelectedCompany,
  SelectedStoregroup
};

@Component({
  components: {
    DisplayFilterMenuComponent,
    SelectComponent,
    InputTextComponent
  }
})
export default class StoreGroupMasterHeaderComponent extends Vue {
  isFilter: boolean = false;
  selectWidth: string = "200px";
  selectLargeWidth: string = "350px";
  inputWidth: string = "200px";
  companyEdit: GetCompanyEditResponse | {} = {};
  storegroupEdit: GetStoregroupEditResponse | {} = {};
  pageNo: number = 1;
  pageCount: number = 10;

  @Prop()
  searchValue!: string;

  @Emit()
  changeCompany(company: SelectedCompany) {
    return company;
  }

  @Emit()
  changeStoregroup(storegroup: SelectedStoregroup) {
    return storegroup;
  }

  @Emit()
  enterSearchValue(event: KeyboardEvent) {
    const inputEvent = event.target as HTMLInputElement;
    return inputEvent.value;
  }

  @Emit()
  changeInputStoreNo(value: string): string {
    return value;
  }

  get internalSearchValue(): string {
    return this.searchValue;
  }

  set internalSearchValue(value: string) {
    this.searchValue = value;
  }

  setCompanyEdit() {
    getCompanyEditApi().then((resp: GetCompanyEditResponse) => {
      this.companyEdit = resp;
    });
  }

  setStoregroups() {
    getStoregroupEditApi().then((resp: GetStoregroupEditResponse) => {
      this.storegroupEdit = resp;
    });
  }

  setValue(key: string, value: any) {
    this[key] = value;
  }

  created() {
    this.setCompanyEdit();
    this.setStoregroups();
  }
}
